import { useRef } from "react";

import ConfirmationPopover from "@/appComponents/Blocks/Composites/ConfirmationPopover/ConfirmationPopover";
import { appstr } from "@coreapp/utils/appstr";
import { Text, Tooltip } from "@theorgchartdev/storybook";

export const DeleteCustomChartPopover = ({
  handleDelete,
  dataTestId,
  onPopoverOpen,
  onPopoverClose,
  canEdit = true,
  isInTrash = false
}) => {
  const openCtrlRef = useRef(null);

  const handleClick = e => {
    e.stopPropagation();
  };

  const handleKeyDown = e => {
    e.stopPropagation();
  };

  const getTitle = () => {
    return isInTrash ? appstr("custom chart delete") + "?" : appstr("custom chart trash") + "?";
  };

  const getMessage = () => {
    return isInTrash ? appstr("custom chart delete message") : appstr("custom chart trash message");
  };

  const getConfirmLabel = () => {
    return isInTrash ? appstr("Delete") : appstr("Trash");
  };

  const getTooltipProps = () => {
    return {
      message: canEdit ? appstr("Delete file") : appstr("Generic insufficient permissions")
    };
  };

  return (
    <div onClick={handleClick} onKeyDown={handleKeyDown}>
      <Tooltip {...getTooltipProps()} referenceOpenCtrlRef={openCtrlRef}>
        <ConfirmationPopover
          openCtrlRef={openCtrlRef}
          onSubmit={handleDelete}
          icon={"trash-can"}
          iconOnly
          iconProps={{
            size: "small"
          }}
          color="error"
          otherHeaderProps={{ title: getTitle() }}
          confirmLabel={getConfirmLabel()}
          triggerTestId={dataTestId}
          popoverProps={{
            onOpen: onPopoverOpen,
            onClose: onPopoverClose
          }}
          disabled={!canEdit}
          dataTestPrefix={dataTestId}
        >
          <Text>{getMessage()}</Text>
        </ConfirmationPopover>
      </Tooltip>
    </div>
  );
};
